export enum Pages {
  onBoarding = "boarding",
  OTP = "otp",
  Register = "register",
  Policy = "policy",
  Payment = "payment",
  ENDING = "ending",
}
